import React, { useState, useEffect, useContext } from "react";
import "./XeesterNavigationBar.scss";
import { useTranslation } from "react-i18next";
import { Dropdown, Button} from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import FilterFolder from "./FilterFolder";
import TreeView from '@material-ui/lab/TreeView';
import { Avatars } from "../../../api/ReplayVariables";
import axios from 'axios';
import { AppContext } from "../../state/AppContext";
import { APP_ACTIONS } from "../../state/AppReducer";
import { SessionContext } from "../../sessions/state/SessionContext";
import { SESSION_ACTIONS } from "../../sessions/state/SessionReducer";
import MenuOpen from "@material-ui/icons/MenuOpen";
import { IconButton } from "@material-ui/core";
import { ToggleButtonGroup, ToggleButton } from "@material-ui/lab";
import { AttachMoney, ClearAll, Deck, Loyalty, LocalAtm, ChevronLeft } from "@material-ui/icons";

function XeesterNavigationBar({ match, history }) {

  const { appState, dispatchAppState } = useContext(AppContext);
  const { sessionState, dispatchSessionState } = useContext(SessionContext);

  const [money, setMoney] = useState('real');
  const handleMoney = (event, newAlignment) => {
    setMoney(newAlignment);
  };

  const [sessionType, setSessionType] = useState(1);
  const handleSessionType = (event, newSessionType) => {
    setSessionType(newSessionType);
  };

  const { t } = useTranslation();

  const switchMoney = (_money) => {
    history.push(
      "/app/content/" +
        match.params.hero +
        "/" +
        _money +
        "/" +
        match.params.sessionType 
    );
  };

  const switchSessionType = (_sessionType) => {
    history.push(
      "/app/content/" +
        match.params.hero +
        "/" +
        match.params.money +
        "/" +
        _sessionType 
    );
  };

  const hideNavigation= (close)=>{
    dispatchAppState({
      type: APP_ACTIONS.NAVIGATION_TOGGLE,
      show: false,
      close : close
    });
  }

  useEffect(() => {
    console.log("XeesterNavigationBar effect");
    axios.get(
      "http://localhost:8099/api/session/filters/", {params:{sessionType : match.params.sessionType}},
    ).then((response)=>{
      //console.log("response", response);
      let folder= response.data;
      //console.log("nodes", _filters);
      dispatchSessionState({
        type: SESSION_ACTIONS.FILTERS_UPDATED,
        payload: folder
      });
    }).catch((err)=>{
      console.error("filters error", err);
    });
    return () => {
      console.log("XeesterNavigationBar effect done!");
    };
  }, [dispatchSessionState, match.params.sessionType]);

  return (
    <>
      <div id="xeester-navigationbar-backdrop" onClick={()=>hideNavigation(false)}></div>
      <div id="xeester-navigationbar">
        <div className="general-nav">
          <div className="general-nav-main">
          <ToggleButtonGroup
            value={money}
            exclusive
            onChange={handleMoney}
            aria-label="text alignment"
          >
            <ToggleButton value="real" aria-label="centered">
              <AttachMoney/>
            </ToggleButton>
            <ToggleButton value="points" aria-label="centered">
              <Loyalty/>
            </ToggleButton>
            <ToggleButton value="fun" aria-label="centered">
              <Deck/>
            </ToggleButton>
          </ToggleButtonGroup>
          <ToggleButtonGroup
            value={sessionType}
            exclusive
            onChange={handleSessionType}
            aria-label="Session type"
          >
            <ToggleButton value={1} aria-label="centered">
              <ClearAll/>
            </ToggleButton>
            <ToggleButton value={2} aria-label="centered">
              <LocalAtm/>
            </ToggleButton>
          </ToggleButtonGroup>
          <ChevronLeft             
            className="close-button"
            onClick={()=>hideNavigation(true)}
          />
          </div>
          <Dropdown className="hero-dropdown">
          <Dropdown.Toggle>
            <div><img src={Avatars.avatarA} alt=""></img><br/>IGotTheNutz<br/><Button><span></span>FISHY</Button></div>
          </Dropdown.Toggle>
          <Dropdown.Menu></Dropdown.Menu>
        </Dropdown>
        </div>
        <PerfectScrollbar>
        <TreeView
          defaultExpanded={["folder--10001"]}
        >
          <FilterFolder match={match} history={history} folder={sessionState.folder} onItemSelect={()=>hideNavigation(false)}></FilterFolder>
        </TreeView>
        </PerfectScrollbar>
        <div className="general-nav-actions"> 
          <Button aria-label="centered">
            <AttachMoney/>
          </Button>
        </div>
      </div>
    </>
  );
}
export default XeesterNavigationBar;
